// extracted by mini-css-extract-plugin
export default {"icon":"MenuIcon_icon__RGa8F"};